import * as React from "react";

import { ActivityType, useXO } from "../../../Common";

import { ReactMyBagAnalyticsInterface } from "./analytics-interface";

export const useAnalyticsXO = () => {
  const { pushToTheDataLayer, consumerInitializationGuard } = useXO();

  const removeFromCartAction: NonNullable<
    ReactMyBagAnalyticsInterface["removeFromCartAction"]
  > = React.useCallback(
    ({ productId }) => {
      let event: ActivityType = {
        action: "remove-from-cart",
        target: {
          product: `${productId}`,
        },
      };

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const initializedInterface: ReactMyBagAnalyticsInterface = React.useMemo(
    () => ({
      hasInitialized: true,
      removeFromCartAction,
    }),
    [removeFromCartAction]
  );
  const analyticsInterface = consumerInitializationGuard({
    initializedInterface,
  });
  return analyticsInterface;
};
